import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'scrTermFilter'
})
export class SCRTermPipe implements PipeTransform {

    transform(arrayObj: any[], requirementId: number, courseId: number): any {
        const returnObject = arrayObj.filter(x => x.DistrictRequirement_ID == requirementId && x.CourseId == courseId);

        // add a blank object
        const blankObj = {
            CourseId: courseId,
            DistrictRequirement_ID: requirementId,
            TextField: ' ',
            ValueField: ' '
        };
        const cObj = returnObject.find(x => x.TextField == ' ' && x.ValueField == ' ');
        if (!cObj) {
            returnObject.splice(0,0,blankObj);
        }
        return returnObject;
    }
}
